export const nameInitial = (name) => {
  let returnString = "-";
  if (name) {
    returnString = name.split(/\s/).reduce((response, word) => response += word.slice(0, 1), '');
  }
  return returnString;
};